import Vue from 'vue'
import message from '@weipu/element-ui-component/packages/message'
import {getCookie} from '@/utils/support'

let projectName = process.env.VUE_APP_PROJECT
let version = process.env.VUE_APP_NODE
console.log('啦啦啦啦啦啦啦啦啦啦啦啦', projectName, version)
let url = 'wss://rabbitmq.ceboshi.cn/ws'
if (version === 'prod') {
    url = 'wss://' + 'rabbitmq.ticlink.cn' + '/ws'
  if (projectName === 'YW') {
    url = 'wss://' + 'rabbitmq.yjwplab.com' + '/ws'
  }
}else {
  url = 'wss://' + 'rabbitmq.ceboshi.cn' + '/ws'
}
let virtualHost = '/mall-pre', username = 'wdt', password = 'wdt'
if (projectName === 'KYC'||projectName === 'YW') {
  if (version === 'prod') {
    virtualHost = '/mall'
  } else if (version === 'test') {
    username = 'mall'
    password = 'mall'
    virtualHost = '/mall'
    url = 'ws://10.0.5.107:30674/ws'
  } else {
    virtualHost = '/mall-pre'
  }
}
if (projectName === 'QYC') {
  if (version === 'prod') {
    virtualHost = '/mall-weixi'
  } else if (version === 'test') {
    username = 'mall'
    password = 'mall'
    virtualHost = '/mall-weixi-test'
    url = 'ws://10.0.5.107:30674/ws'
  } else {
    virtualHost = '/mall-weixi-pre'
  }
}
if (projectName === 'WP') {
  if (version === 'prod') {
    virtualHost = '/mall-corp'
  } else if (version === 'test') {
    username = 'mall'
    password = 'mall'
    virtualHost = '/mall-corp-test'
    url = 'ws://10.0.5.107:30674/ws'
  } else {
    virtualHost = '/mall-corp-pre'
  }
}
Vue.use(message, {
  url: url, // ws 地址
  username: username, // 用户名
  password: password, // 密码
  virtualHost: virtualHost, // 默认值为 /
  debug: version === 'pre',
  getOperatorId: () => {  // 获取当前用户的函数，此方法每2秒钟执行一次
    const username = getCookie('username')
    return username
  }
})



// WEBPACK FOOTER //
// ./src/plugins/websocket.js